import { Search, Filter, Sort, ButtonDropdown, TooltipV2, Button } from '@cimplico/components';
import { FilterResults, SortResult } from '../../components/primary-page-actions/PrimaryPageActions';

type ProceduresPagePrimaryActionsProps = {
    onSearch: (search: string) => void;
    onSort: (sort: string) => void;
    onFilter: (filter: string) => void;
    onNewProcedureClick: () => void;
    onNewCategoryClick: () => void;
    onEditTemplateClick: () => void;
    onSetDefaultClick: () => void;
    onSyncTemplateClick: () => void;
    onDeleteTemplateClick: () => void;
    onDownloadTemplateClick: () => void;
    disablePrimaryButton?: boolean;
    disabledPrimaryButtonHint?: string;
    disableSecondaryButton?: boolean;
    disabledSecondaryButtonHint?: string;
    disableDefaultButton?: boolean;
    disabledDefaultButtonHint?: string;
    disableSyncButton?: boolean;
    disabledSyncButtonHint?: string;
    disableDeleteButton?: boolean;
    disableDeleteButtonHint?: string;
    disableDownloadButton?: boolean;
    disableDownloadButtonHint?: string;
};

function ProceduresPagePrimaryActions({
    onSearch,
    onSort,
    onFilter,
    onNewProcedureClick,
    onNewCategoryClick,
    onEditTemplateClick,
    onSetDefaultClick,
    onSyncTemplateClick,
    onDeleteTemplateClick,
    onDownloadTemplateClick,
    disablePrimaryButton = false,
    disabledPrimaryButtonHint = '',
    disableSecondaryButton = false,
    disabledSecondaryButtonHint = '',
    disableDefaultButton = false,
    disabledDefaultButtonHint = '',
    disableSyncButton = false,
    disabledSyncButtonHint = '',
    disableDeleteButton = false,
    disableDeleteButtonHint = '',
    disableDownloadButton = false,
    disableDownloadButtonHint = '',
}: ProceduresPagePrimaryActionsProps): JSX.Element {
    function handleSearchChange(result: string): void {
        onSearch(result);
    }

    function handleSortChange(result: SortResult): void {
        onSort(result.queryString);
    }

    function handleFilterChange(result: FilterResults): void {
        onFilter(result.queryString);
    }

    return (
        <div className="flex gap-4 items-center">
            {/* <Search onChange={handleSearchChange} placeholder="Search..." />
            <Sort onChange={handleSortChange} sortOptions={[]} enableV2Query />
            <Filter onChange={handleFilterChange} filters={[]} enableV2Query /> */}
            <TooltipV2 message={disableDeleteButtonHint} disabled={!disableDeleteButtonHint} position="left">
                <Button type="danger" label="Delete" onClick={onDeleteTemplateClick} disabled={disableDeleteButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disabledDefaultButtonHint} disabled={!disabledDefaultButtonHint} position="left">
                <Button type="secondary" label="Set as Default" onClick={onSetDefaultClick} disabled={disableDefaultButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disabledSyncButtonHint} disabled={!disabledSyncButtonHint} position="left">
                <Button
                    type="secondary"
                    label="Sync to Open Workpapers"
                    onClick={onSyncTemplateClick}
                    disabled={disableSyncButton}
                    size="sm"
                />
            </TooltipV2>
            <TooltipV2 message={disabledSecondaryButtonHint} disabled={!disabledSecondaryButtonHint} position="left">
                <Button type="secondary" label="Edit Template" onClick={onEditTemplateClick} disabled={disableSecondaryButton} size="sm" />
            </TooltipV2>
            <TooltipV2 message={disableDownloadButtonHint} disabled={!disableDownloadButtonHint} position="left">
                <Button
                    type="secondary"
                    label="Download Template"
                    onClick={onDownloadTemplateClick}
                    disabled={disableDownloadButton}
                    size="sm"
                />
            </TooltipV2>
            <TooltipV2 message={disabledPrimaryButtonHint} disabled={!disabledPrimaryButtonHint} position="left">
                <ButtonDropdown
                    variant="primary"
                    label="New Procedure"
                    onClick={onNewProcedureClick}
                    disabled={disablePrimaryButton}
                    size="sm"
                >
                    <ButtonDropdown.SecondaryAction label="New Category" onClick={onNewCategoryClick} />
                </ButtonDropdown>
            </TooltipV2>
        </div>
    );
}
export default ProceduresPagePrimaryActions;
